import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'
// GrapeJS stylesheet — required for the WYSIWYG editor panels,
// toolbar, and canvas layout to render correctly. Without this the
// builder is unusable.
import 'grapesjs/dist/css/grapes.min.css'
import { ErrorPage } from '@/components/ErrorPage'

Sentry.init({
  dsn: 'https://acdb2f74a943fb88034437e5be5de0fa@o4511000020779008.ingest.us.sentry.io/4511000060755968',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.05,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
